export default __webpack_public_path__ + "static/Orbital_White-aaa9548dd908ba70f78d79e62d82e02f.png";